import { styled } from '@mui/material/styles';
import { RoundedWrapper, Typography } from '@raisin/components-lib';

const lineClamp = (numberOfLines: number) => ({
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: numberOfLines,
  wordBreak: 'break-word',
});

export const BannerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  color: theme.palette.cream100.main,
}));

export const BannerContent = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: theme.spacing(14),

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column-reverse',
    alignItems: 'flex-start',
    gap: theme.spacing(12),
  },

  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(4),
  },
}));

export const ContentSection = styled('div')(({ theme }) => ({
  flex: '1 1 0%',
  [theme.breakpoints.up('lg')]: {
    minWidth: 420,
  },
  [theme.breakpoints.down('lg')]: {
    width: '100%',
    order: 2,
  },
}));

export const Heading = styled(Typography)(({ theme }) => ({
  ...lineClamp(3),
  color: theme.palette.grey900.main,

  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.h2.fontSize,
    lineHeight: theme.typography.h2.lineHeight,
  },

  [theme.breakpoints.down('sm')]: {
    display: 'block',
    fontSize: theme.typography.h3.fontSize,
    lineHeight: theme.typography.h3.lineHeight,
  },
}));

export const ListContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  paddingTop: theme.spacing(6),
  flexDirection: 'column',

  [theme.breakpoints.down('sm')]: {
    paddingTop: theme.spacing(4),
  },
}));

export const ListItem = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
}));

export const SideImageContainer = styled('img')(({ theme }) => ({
  width: 300,
  height: 'auto',

  [theme.breakpoints.down('sm')]: {
    width: 280,
    height: 'auto',
  },
}));

export const SideImageWrapper = styled(RoundedWrapper)(({ theme }) => ({
  width: 516,
  height: 516,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  [theme.breakpoints.down('lg')]: {
    width: 470,
    height: 470,
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: 382,
    maxHeight: 382,
  },
}));

export const CheckmarkIcon = styled('img')(({ theme }) => ({
  width: 24,
  height: 24,
  marginTop: theme.spacing(1),

  [theme.breakpoints.down('sm')]: {
    marginTop: 0,
  },
}));

export const SubTitle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(6),
  display: 'flex',
  alignItems: 'center',

  [theme.breakpoints.down('sm')]: {
    paddingTop: theme.spacing(4),
  },
}));
